import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const testimonials = [{
  quote: 'Hice mi primera mesa ratona en el balcón del apto y quedó igual a las de revista. La guía de proveedores me ahorró semanas buscando materiales.',
  author: 'Martín S.',
  location: 'Montevideo',
  time: 'Hace 3 días',
  tag: 'Compra verificada'
}, {
  quote: 'El capítulo de las burbujas me salvó. Había arruinado dos trabajos antes y con el método de capas por fin me salió perfecto. El pulido espejo es adictivo jaja',
  author: 'Laura G.',
  location: 'Maldonado',
  time: 'Hace 5 días',
  tag: 'Compra verificada'
}, {
  quote: 'Los bonos valen más que el ebook en sí. El de lámparas con resina me abrió la cabeza, ya hice 3 y vendí 2. El de moldes caseros también es oro puro.',
  author: 'Diego R.',
  location: 'Canelones',
  time: 'Hace 1 día',
  tag: 'Compra verificada'
}, {
  quote: 'Pagué $597 y solo con el bono de "El Arte de Vender" ya recuperé la inversión. Apliqué los tips de fotos y me llegaron 4 pedidos la primera semana.',
  author: 'Camila F.',
  location: 'Montevideo',
  time: 'Hace 2 días',
  tag: 'Compra verificada'
}, {
  quote: 'Casi no lo compro pensando que era caro. Al ver los 4 bonos incluidos me decidí y la verdad que al 50% es un regalo. El checklist de seguridad tendría que ser obligatorio.',
  author: 'Federico M.',
  location: 'Salto',
  time: 'Hace 4 días',
  tag: 'Compra verificada'
}, {
  quote: 'Lo mejor es que lo tenés abierto en la mesa mientras trabajás. Seguí el paso a paso del módulo 3 y me salió el efecto río cristalino a la primera. Recomendado 100%.',
  author: 'Valentina P.',
  location: 'Paysandú',
  time: 'Hace 6 días',
  tag: 'Compra verificada'
}];
export function Testimonials() {
  return <section className="py-8 sm:py-14 bg-[#0a0e17] relative" data-id="element-131">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-10" data-id="element-133">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 sm:mb-4" data-id="element-134">
            Resultados reales de quienes ya empezaron
          </h2>
          <p className="text-[#9ca3af] text-sm sm:text-base max-w-xl mx-auto" data-id="element-135">
            Compraron, aplicaron y nos escribieron. Sin filtros.
          </p>
          <div className="w-24 h-1 bg-[#1e6bb8] mx-auto rounded-full" data-id="element-136" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5" data-id="element-137">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-[#111827] rounded-xl border border-[#ffffff]/5 overflow-hidden" data-id="element-138">
              {/* Message body */}
              <div className="p-4 sm:p-5" data-id="element-139">
                <p className="text-[#f5f0e8]/90 text-sm sm:text-[15px] leading-relaxed" data-id="element-140">
                  "{item.quote}"
                </p>
              </div>

              {/* Author footer */}
              <div className="px-4 sm:px-5 pb-4 sm:pb-5 flex items-center justify-between" data-id="element-141">
                <div className="flex items-center gap-2.5" data-id="element-142">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#d4a853] to-[#1e6bb8] flex items-center justify-center text-[#0a0e17] text-xs font-bold shrink-0" data-id="element-143">
                    {item.author[0]}
                  </div>
                  <div data-id="element-144">
                    <div className="flex items-center gap-1" data-id="element-145">
                      <span className="text-white text-sm font-semibold" data-id="element-146">
                        {item.author}
                      </span>
                      <CheckCircle className="w-3.5 h-3.5 text-[#1e6bb8] fill-[#1e6bb8] stroke-[#111827]" data-id="element-147" />
                    </div>
                    <span className="text-[#9ca3af] text-[11px]" data-id="element-148">
                      {item.location}
                    </span>
                  </div>
                </div>
                <span className="text-[#9ca3af]/50 text-[10px] shrink-0" data-id="element-149">
                  {item.time}
                </span>
              </div>

              {/* Verified tag */}
              <div className="border-t border-[#ffffff]/5 px-4 sm:px-5 py-2" data-id="element-150">
                <span className="text-[10px] text-green-400/70 font-medium uppercase tracking-wider" data-id="element-151">
                  ✓ {item.tag}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}